import { Injectable } from '@angular/core';

import { defaultTypography } from '../environments/customer.conf';
import { CustomerConfInterface } from '../interfaces/customerConf.interface';

/**
 * Class for managing stylesheets. Stylesheets are loaded into named slots so that they can be
 * removed or changed later.
 */
@Injectable({ providedIn: 'root' })
export class StyleManager {
  /**
   * Set the stylesheet with the specified key.
   */
  setStyle(key: string, customerConf: CustomerConfInterface): void {
    // In case we want to apply each customer theme when selecting among them, add the corresponding theme files
    // and replace 'euroinnova.css' with `${customerConf.themeName}.css`
    this._getLinkElementForKey(key).setAttribute('href', 'euroinnova.css');
    const typographyFamilyLink = customerConf.typographyFamilyLink
      ? customerConf.typographyFamilyLink
      : defaultTypography;
    this._addTypographyClass(typographyFamilyLink);
  }

  private _getLinkElementForKey(key: string) {
    return this._getExistingLinkElementByKey(key) || this._createLinkElementWithKey(key);
  }

  private _getExistingLinkElementByKey(key: string) {
    return document.head.querySelector(`link[rel="stylesheet"].${this._getClassNameForKey(key)}`);
  }

  private _createLinkElementWithKey(key: string) {
    const linkEl = document.createElement('link');
    linkEl.setAttribute('rel', 'stylesheet');
    linkEl.classList.add(this._getClassNameForKey(key));
    document.head.appendChild(linkEl);

    return linkEl;
  }

  private _getClassNameForKey(key: string) {
    return `style-manager-${key}`;
  }

  private _addTypographyClass(typographyFamilyLink: string) {
    const linkEl = document.createElement('link');
    linkEl.setAttribute('rel', 'stylesheet');
    linkEl.setAttribute('href', typographyFamilyLink);
    document.head.appendChild(linkEl);
  }
}
